import React from 'react';
import compose from 'recompose/compose';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import { GET_ONE, translate } from 'react-admin';
import FormControl from '@material-ui/core/FormControl';
import dataProvider from '../../dataProvider';

const style = theme => ({
  formControl: {
    minWidth: 250,
    marginRight: '5em',
    marginLeft: '5em',
    display: 'flex',
    flexWrap: 'wrap',
  },
  root: {
    flex: 1,
  },
  cost: {
    marginRight: '1em',
    color: theme.palette.text.primary,
  },
});

class ContractInfo extends React.Component {
  state = {
    license: '',
    inUseLicense: '',
  };

  componentDidMount() {
    dataProvider(GET_ONE, 'tenants', { id: 'me' })
      .then(response => response.data)
      .then(data => {
        this.setState({ license: data.monitableResourceCount });
        this.setState({ inUseLicense: data.monitoringResourceCount });
      });
  }

  render() {
    const { translate, classes } = this.props;
    return (
      <Card>
        <List>
          <ListItem>
            <ListItemText primary={translate('contract.title')} />
          </ListItem>
          <ListItem>
            <FormControl className={classes.formControl}>
              <ListItemText
                primary={translate('contract.license')}
                secondary={this.state.license}
                className={classes.listItemText}
              />
            </FormControl>
          </ListItem>
          <ListItem>
            <FormControl className={classes.formControl}>
              <ListItemText
                primary={translate('contract.inUseLicense')}
                secondary={this.state.inUseLicense}
                className={classes.listItemText}
              />
            </FormControl>
          </ListItem>
        </List>
      </Card>
    );
  }
}

const enhance = compose(withStyles(style), translate);

export default enhance(ContractInfo);
